"use client";

import {
  type Cart as CartData,
  CartType,
} from "@cappelendamm/e-commerce-services";
import * as actions from "./actions";
import { INITIAL_CART } from "./initial-cart";
import Logger from "@cappelendamm/logger";

export async function cartActionReducer(
  cartData: CartData,
  actionPayload:
    | { type: "ADD"; sku: string; quantity: number }
    | { type: "REMOVE"; sku: string }
    | { type: "INCREASE"; sku: string; quantity: number }
    | { type: "DECREASE"; sku: string; quantity?: number }
    | { type: "SET_QUANTITY"; sku: string; quantity: number }
    | { type: "SET_CART"; cartData: CartData }
    | { type: "LOAD" }
    | { type: "CLEAR" }
    | {
        type: "SWAP";
        currentCartId: string;
        currentCartType: CartType;
        targetCartType: CartType;
        skus?: string[];
      }
    | { type: "ADD_VOUCHER_CODE"; voucherCode: string[] },
) {
  switch (actionPayload.type) {
    case "ADD": {
      return (await actions.addItem(actionPayload)).cart;
    }
    case "REMOVE": {
      return (await actions.removeItem(actionPayload)).cart;
    }
    case "INCREASE": {
      return (await actions.increaseQuantity(actionPayload)).cart;
    }
    case "DECREASE": {
      return (await actions.decreaseQuantity(actionPayload)).cart;
    }
    case "SET_QUANTITY": {
      return (await actions.setQuantity(actionPayload)).cart;
    }
    case "SET_CART": {
      return actionPayload.cartData;
    }
    case "LOAD": {
      try {
        return (await actions.loadCurrentCart()) ?? { ...INITIAL_CART };
      } catch (error) {
        Logger.warn("Failed to load cart; using initial cart", error);
        return { ...INITIAL_CART };
      }
    }
    case "CLEAR": {
      await actions.clearCart({ cartType: cartData.cartType });
      return { ...INITIAL_CART, cartType: cartData.cartType };
    }
    case "SWAP": {
      return await actions.swapCart({
        currentCartId: actionPayload.currentCartId,
        currentCartType: actionPayload.currentCartType,
        targetCartType: actionPayload.targetCartType,
        skus: actionPayload.skus,
      });
    }
    case "ADD_VOUCHER_CODE": {
      return await actions.addVoucherCodeToCart({
        voucherCode: actionPayload.voucherCode,
      });
    }
  }
}
